// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateSeller_pageWrap__s1sEi {
  padding: 4px 4px 32px;
}

.UpdateSeller_sectionTitle__kAhMu {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #4c2fb3;
  margin: 26px 0 14px;
  padding-top: 14px;
  border-top: 1px solid #EEF0F6;
}
.UpdateSeller_sectionTitle__kAhMu:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.UpdateSeller_verifiedTag__kaurR {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #16A34A;
  font-size: 11px;
  font-weight: 700;
  margin-left: 8px;
}

.UpdateSeller_submitRow__KErz2 {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

/* Light violet-themed polish for the multiselect-react-dropdown library's
   default markup, without fighting its internal styling. */
.UpdateSeller_field__llTau .multiSelectContainer .searchWrapper {
  border: 1px solid #E5E7EB !important;
  border-radius: 10px !important;
  padding: 6px 10px !important;
}
.UpdateSeller_field__llTau .multiSelectContainer .searchWrapper input {
  font-size: 13.5px;
}
.UpdateSeller_field__llTau .multiSelectContainer .optionListContainer {
  border-radius: 10px !important;
  border: 1px solid #E7E9F1 !important;
  box-shadow: 0 12px 28px rgba(27, 37, 89, 0.12) !important;
}
.UpdateSeller_field__llTau .multiSelectContainer .highlightOption,
.UpdateSeller_field__llTau .multiSelectContainer li:hover {
  background: #F5F3FE !important;
  color: #4c2fb3 !important;
}
.UpdateSeller_field__llTau .multiSelectContainer .chip {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  border-radius: 20px !important;
}

.UpdateSeller_datePickerWrap__MkHtC {
  margin-bottom: 10px;
}
.UpdateSeller_datePickerWrap__MkHtC .react-datepicker__input-container input {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  width: 100%;
}
.UpdateSeller_datePickerWrap__MkHtC .react-datepicker__input-container input:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.UpdateSeller_holidayList__Qmukf {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  padding: 10px;
  min-height: 44px;
  border: 1px solid #EEF0F6;
  border-radius: 10px;
  background: #FAFAFD;
}

.UpdateSeller_holidayChip__fpINZ {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
}

.UpdateSeller_holidayRemove__B-IbD {
  cursor: pointer;
  font-weight: 700;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/updateseller/UpdateSeller.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;2DAC2D;AAC3D;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yDAAyD;AAC3D;AACA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.sectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #4c2fb3;\n  margin: 26px 0 14px;\n  padding-top: 14px;\n  border-top: 1px solid #EEF0F6;\n}\n.sectionTitle:first-child {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n}\n\n.verifiedTag {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  color: #16A34A;\n  font-size: 11px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n.submitRow {\n  display: flex;\n  justify-content: center;\n  margin-top: 28px;\n}\n\n/* Light violet-themed polish for the multiselect-react-dropdown library's\n   default markup, without fighting its internal styling. */\n.field :global(.multiSelectContainer .searchWrapper) {\n  border: 1px solid #E5E7EB !important;\n  border-radius: 10px !important;\n  padding: 6px 10px !important;\n}\n.field :global(.multiSelectContainer .searchWrapper input) {\n  font-size: 13.5px;\n}\n.field :global(.multiSelectContainer .optionListContainer) {\n  border-radius: 10px !important;\n  border: 1px solid #E7E9F1 !important;\n  box-shadow: 0 12px 28px rgba(27, 37, 89, 0.12) !important;\n}\n.field :global(.multiSelectContainer .highlightOption),\n.field :global(.multiSelectContainer li:hover) {\n  background: #F5F3FE !important;\n  color: #4c2fb3 !important;\n}\n.field :global(.multiSelectContainer .chip) {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  border-radius: 20px !important;\n}\n\n.datePickerWrap {\n  margin-bottom: 10px;\n}\n.datePickerWrap :global(.react-datepicker__input-container input) {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  width: 100%;\n}\n.datePickerWrap :global(.react-datepicker__input-container input:focus) {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.holidayList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n  padding: 10px;\n  min-height: 44px;\n  border: 1px solid #EEF0F6;\n  border-radius: 10px;\n  background: #FAFAFD;\n}\n\n.holidayChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 20px;\n}\n\n.holidayRemove {\n  cursor: pointer;\n  font-weight: 700;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `UpdateSeller_pageWrap__s1sEi`,
	"sectionTitle": `UpdateSeller_sectionTitle__kAhMu`,
	"verifiedTag": `UpdateSeller_verifiedTag__kaurR`,
	"submitRow": `UpdateSeller_submitRow__KErz2`,
	"field": `UpdateSeller_field__llTau`,
	"datePickerWrap": `UpdateSeller_datePickerWrap__MkHtC`,
	"holidayList": `UpdateSeller_holidayList__Qmukf`,
	"holidayChip": `UpdateSeller_holidayChip__fpINZ`,
	"holidayRemove": `UpdateSeller_holidayRemove__B-IbD`
};
export default ___CSS_LOADER_EXPORT___;
